import type { EvaluationEmailRecipientRequest, DefaultApi } from "@/api";
import { EvaluationEmailRecipient } from "@/models/evaluation_email_recipient";
import { EvaluationEmailRecipients } from "@/models/evaluation_email_recipients";
import type { State as RootState } from "@/stores";
import { type Module } from "vuex";

export interface State {
  recipients?: EvaluationEmailRecipients;
}

export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    recipients: undefined,
  },
  actions: {
    async getEvaluationEmailRecipients({ commit }, positionId: number) {
      const api = (await this.dispatch("getAuthorizedApi", null, {
        root: true,
      })) as DefaultApi;
      try {
        const response = await api.getEvaluationEmailRecipients(positionId);
        const recipients = new EvaluationEmailRecipients(
          response.data.map(
            (recipient) => new EvaluationEmailRecipient(recipient),
          ),
        );
        commit("setRecipients", recipients);
        return recipients;
      } catch (error) {
        commit("setRecipients", undefined);
        throw error;
      }
    },
    async postEvaluationEmailRecipients(
      { commit },
      {
        positionId,
        recipients,
      }: {
        positionId: number;
        recipients: EvaluationEmailRecipientRequest[];
      },
    ) {
      const api = (await this.dispatch("getAuthorizedApi", null, {
        root: true,
      })) as DefaultApi;
      const response = await api.postEvaluationEmailRecipients(
        positionId,
        recipients,
      );
      const updated = new EvaluationEmailRecipients(
        response.data.map(
          (recipient) => new EvaluationEmailRecipient(recipient),
        ),
      );
      commit("setRecipients", updated);
      return updated;
    },
  },
  mutations: {
    setRecipients(state, recipients: EvaluationEmailRecipients) {
      state.recipients = recipients;
    },
  },
};
